// 联系方式配置文件
export default {
  // 品牌信息
  brand: {
    name: 'YUANXING',
    fullName: 'YUANXING Studio',
    logo: require('../images/logo.jpg')
  },
  // Telegram客服链接
  telegram: {
    url: 'https://t.me/yuanxingkefu',
    name: 'YUANXING客服',
    handle: '@yuanxingkefu'
  },

  // 公司地址信息
  address: {
    chinese: '赫伯罗特大厦 AL SHUALAH 1 STREET, 德拉 迪拜 55586 阿拉伯联合酋长国',
    english: 'HAPAG-LLOYD BUILDING AL SHUALAH 1 STREET, DEIRA DUBAI 55586 UNITED ARAB EMIRATES',
  },

  // 联系电话
  phone: '+971 4 2041111',

  // 工作时间
  workingHours: {
    weekdays: '星期一至星期五 09.00 — 23.00',
    weekends: '星期六至星期天 11.00 — 02.00'
  }
};



// WEBPACK FOOTER //
// ./src/config/contact.js